import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";
import { PropertyFieldApiPayload } from "../components/property-details/default/utils/property-fields-transformer";

export const usePropertyFields = (propertyId: number) => {
  return useQuery({
    queryKey: ["property-fields", propertyId],
    queryFn: async () => {
      const { data } = await api.get<PropertyFieldApiPayload[]>(`/properties/${propertyId}/fields`);
      return data;
    },
  });
};
